export enum OrderExceptionsTracingMessages {
  capability = 'Order Exceptions',
  submitExceptionsEvent = 'submit exceptions',
  viewExceptions = 'View Exceptions',
  pageLoad = 'Resolve Exceptions Page Load',
}
